export const GET_POSITIONS_SUCCESS = 'GET_POSITIONS_SUCCESS';
export const GET_POSITIONS_ERROR = 'GET_POSITIONS_ERROR';
